import saveAs from 'file-saver';

export const getMentorConnect = (params, successCallback = () => {}) => {
  fetch(`/api/v1/mentor_connect?${objToQueryString(params)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // Pass both users and pagination metadata to callback
      successCallback(data.users || [], data.meta || {});
    });
};

export const getMentorConnectExport = (params) => {
  return fetch(`/api/v1/mentor_connect/export?${objToQueryString(params)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/csv',
    },
  })
    .then((response) => {
      const filename = response.headers.get('X-Filename') || 'export.csv';
      return response.blob().then((blob) => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      saveAs(blob, filename);
      return new Promise((resolve) => {
        // Give a small delay to ensure the file save dialog has appeared
        setTimeout(resolve, 100);
      });
    });
};
